import styled from 'styled-components';

export const ChecklistStyled = styled.div`
  .card-wrapper .Polaris-ShadowBevel .Polaris-Box {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .text-embed .Polaris-Link {
    color: #303030;
  }

  .card-flex-column .Polaris-ShadowBevel .Polaris-Box {
    flex-direction: column;
    align-items: flex-start;
    .card-container .Polaris-ShadowBevel .Polaris-Box {
      cursor: pointer;
      align-items: center;
      .card-icon {
        text-align: center;
      }
    }
  }
`;
